import { ValidationSchema } from '../../../../../../../validations/interfaces';
import { Validation } from '../../../../../../../validations/Validation';
import loanFormModel from '../../../../../../../components/loan_application/form_models/loanFormModel';
import { BusinessRuleBase } from '../../business/BusinessBase';
import { GenericValidation } from '../../../../../../../validations/GenericValidation';

const {
  formField: { principalZip },
} = loanFormModel;

export class PrincipalZipValidation implements ValidationSchema {
  public name = principalZip.name;
  public label = '';
  public dependsOn: string[] = [];
  public type = 'string';
  public required = {
    message: principalZip.requiredErrorMsg,
    value: principalZip.required,
  };
  public nullable = true;
  public min = {
    value: 5,
    message: 'Must be exactly 5 digits',
  };
  public max = {
    value: 5,
    message: 'Must be exactly 5 digits',
  };
  public matches = {
    value: /^[0-9]+$/,
    message: 'Must be only digits',
  };

  public when(schema: any, context: any) {
    const bl = new BusinessRuleBase(context.parent);
    if (bl.isPrincipal() && !bl.isTrust())
      return schema.required(principalZip.requiredErrorMsg);

    return GenericValidation.create({
      nullable: true,
      required: false,
    });
  }
}
export default new Validation(new PrincipalZipValidation());
